export default __webpack_public_path__ + "static/media/rgt-img-3.ddf68375.jpg";